export const UNITS_DISPLAY: Record<string, string> = {
  Knot: 'kt',
  MeterPerSecond: 'm/s',
  KilometerPerHour: 'km/h',
  Degree: '°',
  DegreeCelsius: 'C',
  DegreeFahrenheit: 'F',
  Kelvin: 'K',
};
